import { useEffect, useState } from "react";
import { IVrRetailContainerProps } from "./VrRetail.interfaces";
import VrRetailView from "./VrRetail.view";
import BroswerService from "../../Services/Browser.service";
export default function VrRetailContainer(props: IVrRetailContainerProps) {
    useEffect(() => {
        BroswerService.setCustomTitle("VrRetailContainer");
    }, []);
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    const [showlogin, setShowlogin] = useState(false);
    const loginController = () => setShowlogin(!showlogin);
    return (
        <>
            <VrRetailView
                demoController={demoController}
                showDemo={showDemo}
                loginController={loginController}
                showlogin={showlogin}
            />
        </>
    );
}
